import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { SPEECHES, WRITINGS, HOBBIES } from '../../data/staticContent';

const ActivitiesOfChaitralee = () => {
  const { t } = useLanguage();

  return (
    <>
      {/* ── Speeches ────────────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div className="row g-5 align-items-start">

            {/* Sticky sidebar */}
            <div className="col-lg-4">
              <div className="sticky-sidebar">
                <span className="eyebrow">
                  <i className="bi bi-mic-fill me-2"></i>
                  {t('chaitraleeAct.speechesVoiceLabel')}
                </span>
                <h2 className="section-title">{t('chaitraleeAct.speechesTitle')}</h2>
                <div className="divider-brand"></div>
                <p className="body-text">{t('chaitraleeAct.speechesVoiceDesc')}</p>
                <div className="sidebar-quote-box mt-3">
                  <i className="bi bi-award-fill" style={{fontSize:'2rem',opacity:0.2,display:'block',marginBottom:'0.5rem'}}></i>
                  <div className="sidebar-quote-text">
                    "A voice like hers comes once in a generation."
                  </div>
                  <div className="sidebar-quote-attr">— SP College, Vaadasabha</div>
                </div>
              </div>
            </div>

            {/* Speech cards */}
            <div className="col-lg-8">
              <div className="d-flex flex-column gap-3">
                {SPEECHES.map(({ key, icon, speechCardClass }, i) => (
                  <div key={key} className={`${speechCardClass} anim-fade-up anim-delay-${i + 1}`}>
                    <div className="d-flex gap-3 align-items-start">
                      <div className="card-icon-wrap card-icon-primary" style={{width:'44px',height:'44px',borderRadius:'10px',flexShrink:0}}>
                        <i className={`bi ${icon}`}></i>
                      </div>
                      <div>
                        <div className="cf-card-title">{t(`chaitraleeAct.${key}Title`)}</div>
                        <p className="cf-card-text mb-0">{t(`chaitraleeAct.${key}Text`)}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── Quote divider ───────────────────────── */}
      <section className="quote-section">
        <div className="container position-relative" style={{zIndex:1}}>
          <blockquote className="quote-text">{t('home.quote')}</blockquote>
          <p className="quote-author mt-3">{t('home.quoteAuthor')}</p>
        </div>
      </section>

      {/* ── Writings ────────────────────────────── */}
      <section className="section-pad-alt">
        <div className="container">
          <div className="text-center mb-5">
            <span className="eyebrow">
              <i className="bi bi-pen me-2"></i>
              {t('chaitraleeAct.writingsWordsLabel')}
            </span>
            <h2 className="section-title">{t('chaitraleeAct.writingsTitle')}</h2>
            <div className="divider-brand-center"></div>
          </div>

          <div className="row g-4">
            {WRITINGS.map(({ key, icon, cardClass }, i) => (
              <div className="col-lg-6" key={key}>
                <div className={`${cardClass} anim-fade-up anim-delay-${i + 1}`}>
                  <div className={`card-icon-wrap ${i === 0 ? 'card-icon-primary' : 'card-icon-secondary'} mb-3`}>
                    <i className={`bi ${icon}`}></i>
                  </div>
                  <div className="cf-card-title">{t(`chaitraleeAct.${key}Title`)}</div>
                  <p className="cf-card-text mb-3">{t(`chaitraleeAct.${key}Text`)}</p>
                  <div className="writing-note">
                    <p>{t(`chaitraleeAct.${key}Note`)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Info note */}
          <div className="info-note mt-4 d-flex align-items-start gap-2">
            <i className="bi bi-info-circle-fill text-accent flex-shrink-0 mt-1"></i>
            <span>{t('chaitraleeAct.writingInfoNote')}</span>
          </div>
        </div>
      </section>

      {/* ── Hobbies ─────────────────────────────── */}
      <section className="section-pad">
        <div className="container">
          <div className="text-center mb-5">
            <span className="eyebrow">
              <i className="bi bi-heart me-2"></i>
              {t('chaitraleeAct.writingsPassionsLabel')}
            </span>
            <h2 className="section-title">{t('chaitraleeAct.hobbiesTitle')}</h2>
            <div className="divider-brand-center"></div>
          </div>

          <div className="row g-4">
            {HOBBIES.map(({ key, icon, iconClass }, i) => (
              <div className="col-lg-4 col-md-6" key={key}>
                <div className={`talent-card anim-fade-up anim-delay-${i + 1}`}>
                  <div className={`talent-icon ${iconClass}`}>
                    <i className={`bi ${icon}`}></i>
                  </div>
                  <div>
                    <div className="talent-name">{t(`chaitraleeAct.${key}`)}</div>
                    <p className="talent-desc mb-0">{t(`chaitraleeAct.${key}Desc`)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ActivitiesOfChaitralee;
